"use strict";
const createSearchStringQuery = search => {
    const searches = {
        or: [
            {
                '$customerSubUnit.name$': {
                    iLike: `%${search.replace(' ', '%')}%`,
                },
            },
            { OCR: { iLike: `%${search.replace(' ', '%')}%` } },
            { yourOrderNumber: { iLike: `%${search.replace(' ', '%')}%` } },
            { externalInvoiceReference1: { iLike: `%${search.replace(' ', '%')}%` } },
            { externalInvoiceReference2: { iLike: `%${search.replace(' ', '%')}%` } },
        ],
    };
    const numberParse = Number.parseInt(search, 10);
    if (numberParse) {
        searches.or.push({
            invoiceNumber: { eq: Number.parseInt(search, 10) || undefined },
        });
    }
    return searches;
};
module.exports = createSearchStringQuery;
